// extracted by mini-css-extract-plugin
module.exports = {"drawerLogoLink":"Logo_drawerLogoLink__1jmZu","logoLink":"Logo_logoLink__2lyx4","logoIcon":"Logo_logoIcon__3IXQt"};